let currentlyPlaying = null;

document.querySelectorAll('.card').forEach(card => {
  const playIcon = card.querySelector('.play-icon');

  if (!playIcon) return;

  playIcon.addEventListener('click', function () {
    // If a video is already playing somewhere else, stop it
    if (currentlyPlaying && currentlyPlaying !== card) {
      const oldVideo = currentlyPlaying.querySelector('video');
      const oldImage = currentlyPlaying.querySelector('.card-image');
      const oldIcon = currentlyPlaying.querySelector('.play-icon');

      if (oldVideo) oldVideo.remove();
      if (oldImage) oldImage.style.display = '';
      if (oldIcon) oldIcon.style.display = '';
    }

    // Prevent multiple videos in same card
    if (card.querySelector('video')) return;

    const videoUrl = card.getAttribute('data-video');
    if (!videoUrl) {
      alert('No video assigned!');
      return;
    }

    const video = document.createElement('video');
    video.src = videoUrl;
    video.controls = false;
    video.autoplay = true;
    video.style.cssText = `
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 10;
      object-fit: cover;
      border-radius: 8px;
    `;

    const cardImage = card.querySelector('.card-image');
    if (cardImage) cardImage.style.display = 'none';
    playIcon.style.display = 'none';

    card.appendChild(video);
    currentlyPlaying = card;

    video.addEventListener('ended', function () {
      video.remove();
      if (cardImage) cardImage.style.display = '';
      playIcon.style.display = '';
      currentlyPlaying = null;
    });
  });
});

